import { useTranslation } from 'react-i18next';

export function useGuestLabel(location: string) {
  const { t } = useTranslation(location);
  const getGuestLabel = (adults: number, children: number) => {
    const adultLabel = t(
      `guests.adult${adults !== 1 ? '_plural' : ''}`,
      { count: adults }
    );
    const childLabel = t(
      `guests.child${children !== 1 ? '_plural' : ''}`,
      { count: children }
    );

    const parts = [];
    if (adults > 0) parts.push(adultLabel);
    if (children > 0) parts.push(childLabel);

    return parts.join(', ');
  };

  return getGuestLabel;
}
